import React, { useState } from 'react'
import { Tabs } from './components/Tabs.js'
import { RoomList } from './components/RoomList.js'
import { RoomView } from './components/RoomView.js'
import { QuickBook } from './components/QuickBook.js'
import { Calendar } from './components/Calendar.js'
import { Loader2 } from 'lucide-react'
import { View } from './view.js'

export interface RootProps {
    view: View
}

export const Root = (props: RootProps) => {
    const { view } = props
    const [activeTab, setActiveTab] = useState<'rooms' | 'calendar'>('rooms')

    if (view.state.isLoading) {
        return (
            <div className="px-6 pb-16 flex justify-center items-center py-12">
                <Loader2 className="w-8 h-8 animate-spin text-gray-500" />
            </div>
        )
    }

    if (view.state.latestError) {
        return (
            <div className="px-6 pb-16">
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
                    <p>Error loading rooms: {view.state.latestError}</p>
                </div>
            </div>
        )
    }
    return (
        <div className="min-h-screen bg-[#f3f3f3]">
            <div className="mx-auto max-w-[768px] w-full">
                <div className="relative size-full overflow-hidden">
                    <div className="box-border content-stretch flex flex-col items-start justify-start p-0 relative size-full">
                        {view.state.selectedRoomId ? (
                            // Show single room view when a room is selected
                            <RoomView
                                room={view.state.rooms.find(room => room.id === view.state.selectedRoomId)!}
                                view={view}
                            />
                        ) : (
                            // Show tabs and room list or calendar when no room is selected
                            <>
                                <QuickBook rooms={view.state.rooms} />
                                <Tabs activeTab={activeTab} onTabChange={setActiveTab} />
                                {activeTab === 'rooms' ?
                                    <RoomList rooms={view.state.rooms} view={view} /> :
                                    <Calendar rooms={view.state.rooms} />
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
